import loader from '../moduleLoader.js';
import { setTimeout } from 'timers';

class SearchOverlay {
    constructor(button) {
        this.button = button;
        this.overlayTemplate = `<div class="search-overlay" id="searchOverlay"></div>`;
        this.overlayInput = document.getElementById('searchOverlay__input');
        this.resultContainer = document.getElementById('searchOverlay__resultContainer');
        this.errorResultElement = this.resultContainer.innerHTML;
        this.resultItemHeight = 121;
        this.results = 0;
        this.visibleResults = 3;
        this.minimumSearchCharacters = 3;
        this.delay = 300;
        this.timer = null;
        this.term = "";
        this.isMobile = false;
    }
    init() {
        this.button.addEventListener('click', this.openOverlay.bind(this));
        this.overlayInput.addEventListener('keyup', this.handleKeyUp.bind(this));

        window.addEventListener('resize', this.resizeHandler.bind(this));
        this.setScreenMode();
    }

    setScreenMode() {
        if (document.body.clientWidth < 481) {
            this.isMobile = true;
            this.resultItemHeight = 101;
        } else {
            this.isMobile = false;
            this.resultItemHeight = 121;
        }
    }

    openOverlay(e) {
        e.preventDefault();
        this.setInputStyle();

        // Fetch and populate personalized property
        if (this.button.className.indexOf('personalized') > -1) {
            window.setTimeout(function () {
                this.fetchPersonalizedItem(
                    function (responseText) {
                        this.populateResult(responseText);
                    }.bind(this),
                    function() {
                        this.showError();
                    }.bind(this)
                );
            }.bind(this), this.delay);
        }

        let overlayContainer = document.getElementById('searchOverlay__container');
        overlayContainer.style.display = "block";

        // Faded overlay backdrop
        let overlay = this.overlayTemplate;
        document.body.insertAdjacentHTML('beforeend', overlay);
        let overlayElement = document.getElementById('searchOverlay');
        overlayElement.addEventListener('click', this.closeOverlay.bind(this));
        document.addEventListener('keydown', this.handleEscKey.bind(this));

        // Trigger animation
        overlayElement.classList.add("search-overlay--visible");
        overlayContainer.classList.add("search-overlay__container--visible");

        this.overlayInput.focus();
    }

    closeOverlay() {
        let overlayContainer = document.getElementById('searchOverlay__container');
        let overlay = document.getElementById('searchOverlay');
        this.clearResult();
        this.overlayInput.value = this.term = "";
        this.results = 0;
        this.updateContainers();

        if (overlay) {
            overlay.removeEventListener('click', this.closeOverlay.bind(this));
            document.removeEventListener('keydown', this.handleEscKey.bind(this));

            overlay.classList.remove("search-overlay--visible");
            overlayContainer.classList.remove("search-overlay__container--visible");

            setTimeout(function () {
                overlay.remove();
                overlayContainer.style.display = "none";
            }, 200);
        }
    }

    handleEscKey(e) {
        if (e.key === 'Escape') {
            this.closeOverlay();
        }
        if (e.keyCode === 40) {
            console.log('down');
            return;
        }
    }

    clearResult() {
        this.resultContainer.innerHTML = '';
        this.results = 0;
        clearTimeout(this.timer);
    }

    handleKeyUp(e) {
        this.term = e.target.value.trim();
        if (!window.searchPropertyXHR) {
            window.searchPropertyXHR = new XMLHttpRequest();
        }
        window.clearTimeout(this.timer);
        window.searchPropertyXHR.abort();

        if (this.term.length >= this.minimumSearchCharacters) {
            this.showLoader();
            this.timer = window.setTimeout(function () {
                this.fetchResult(
                    this.term,
                    function (responseText) {
                        this.populateResult(responseText);
                    }.bind(this),
                    function () {
                        this.showError();
                    }.bind(this)
                );
            }.bind(this), this.delay);
        } else {
            this.clearResult();
            this.updateContainers();
        }
    }

    showLoader() {
        console.log('loading');
    }

    hideLoader() {
        console.log('loading done');
    }

    showError() {
        this.clearResult();
        this.resultContainer.insertAdjacentHTML('beforeend', this.errorResultElement);

        let container = document.getElementById('searchOverlay__container');
        this.resultContainer = document.getElementById('searchOverlay__resultContainer');

        container.style.height =  40 + this.overlayInput.offsetHeight + "px";
        this.resultContainer.style.height = 40 + "px";
    }

    fetchResult(term, successCallback, errorCallback) {
        const url = "/TenantPage/GetPropertyHits/?term=" + term;

        window.searchPropertyXHR.abort();
        searchPropertyXHR.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                console.log('Error fetching suggestions');
                errorCallback();
                return;
            }
            successCallback(this.responseText);
        };

        searchPropertyXHR.open('GET', url, true);
        searchPropertyXHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        searchPropertyXHR.send();
    }

    fetchPersonalizedItem(successCallback, errorCallback) {
        const url = "/TenantPage/GetPersonalizedProperty";
        
        window.searchPropertyXHR = new XMLHttpRequest();
        searchPropertyXHR.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                console.log('Error fetching suggestions');
                errorCallback();
                return;
            }
            successCallback(this.responseText);
        };

        searchPropertyXHR.open('GET', url, true);
        searchPropertyXHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        searchPropertyXHR.send();
    }

    populateResult(responseText) {
        this.hideLoader();
        this.clearResult();
        
        this.resultContainer.insertAdjacentHTML('beforeend', responseText);
        var resultItems = this.resultContainer.getElementsByClassName('search-overlay__result');
        Array.from(resultItems).forEach((result) => {
            var target = result.getElementsByClassName('search-overlay__result__body')[0].children[0].children[0].getAttribute('href');
            result.addEventListener('click', function () { window.location.href = target; });
        });
        this.results = resultItems.length;
        this.updateContainers();
    }

    updateContainers() {
        let container = document.getElementById('searchOverlay__container');

        if (this.results === 0 && this.term.length >= this.minimumSearchCharacters) {
            container.style.height =  40 + this.overlayInput.offsetHeight + "px";
            this.resultContainer.style.height = 40 + "px";
        } else {
            container.style.height = (this.visibleResults >= this.results ? this.results : this.visibleResults) * this.resultItemHeight + this.overlayInput.offsetHeight + "px";
            this.resultContainer.style.height = (this.visibleResults >= this.results ? this.results : this.visibleResults) * this.resultItemHeight + "px";
        }
    }

    getInputMeasures() {
        let inputWidth = document.body.offsetWidth - 2 * this.button.offsetLeft;
        let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

        return {
            left: this.button.offsetLeft,
            top: this.button.getBoundingClientRect().top + scrollTop,
            width: inputWidth
        };
    }

    setInputStyle() {
        let overlayContainer = document.getElementById('searchOverlay__container');
        let measures = this.getInputMeasures();

        if (!this.isMobile) {
            overlayContainer.style.top = Math.ceil(measures.top) + "px";
            if (measures.width < 400) {
                overlayContainer.style.left = "60px";
                overlayContainer.style.right = "60px";
            } else {
                overlayContainer.style.left = measures.left + "px";
                overlayContainer.style.width = this.button.offsetWidth + "px";

                setTimeout(function () {
                    overlayContainer.style.width = measures.width + "px";
                }, 300);
            }
        }
    }

    resizeHandler() {
        this.setScreenMode();
    }
}

loader.add('SearchOverlay', SearchOverlay);

export default SearchOverlay;